
import React from 'react';

const ArrowRight = ({ width = 14, height = 12, color = "#fff" }) => (
    <svg width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33333 1.33333L13 6M13 6L8.33333 10.6667M13 6H1" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default ArrowRight;